const o = [
  "list",
  "strike",
  "underline",
  "link",
  "bold",
  "italic",
  "image",
  "clean",
  "align",
  "video",
  "header",
  "script",
  "blockquote",
  "code",
  "code-block"
];
function i(e) {
  o.forEach((c) => {
    e[c] = {};
  });
}
export {
  i as replaceIcons
};
